import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import specialService from "../../../services/metaData.service";
import metaData from "../../../services/metaData.service";

const initialValues = {
    title: "",
    href: "",
};

const schema = Yup.object().shape({
    title: yupSchema.title,
    href: yupSchema.destinationURL,
});

const form = [
    {
        _type: "textField",
        name: "title",
        label: "عنوان",
        autoFocus: true,
    },
    {
        _type: "textField",
        name: "href",
        label: "آدرس مقصد",
    },
];

export default function FormModalContent(props) {
    const { close, data, allSpecials = [] } = props;

    const handleSubmit = async (model, { setSubmitting }) => {
        let dataToSave = [...allSpecials]
        if(data && data?.id){
            dataToSave = dataToSave.map(it => {
                if(it.id === data.id){
                    it = {...data, ...model}
                }
                return it
            })
        } else {
            dataToSave.push(model)
        }

        await metaData.setMetaData("special", dataToSave);
        setSubmitting(false);
        close(true);
    };

    return (
        <DialogFormBuilder
            {...{
                close,
                name: "ویژه",
                data,
                schema,
                initialValues,
                handleSubmit,
                form,
            }}
        />
    );
}
